module.exports = __webpack_public_path__ + "img/intro3.01b6ae8b.svg";